import React from 'react';
import SocialLink from './social-link';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import { fadeIn } from 'react-animations';
import { keyframes } from '@emotion/react';
import { PAtom } from '@atoms/text-atoms/text-atoms';
import { SocialLinksProps } from './social-links.types';

const SocialLinks: React.FC<SocialLinksProps> = ({
  socialLinks = [],
  fill,
  translate = true,
  className,
}) => {
  if (Array.isArray(socialLinks) && socialLinks.length > 0) {
    return (
      <div className={className}>
        <PAtom>{Translate('Follow us', translate)}</PAtom>
        <ul>
          {socialLinks.map((socialLink, index) => (
            <SocialLink
              key={`${index}--${socialLink.type.slice(0, 2)}`}
              type={socialLink.type}
              url={socialLink.url}
              alt={socialLink.alt}
              width={socialLink.width}
              height={socialLink.height}
              fill={fill}
              to={socialLink.url}
            />
          ))}
        </ul>
      </div>
    );
  } else return null;
};

export const StyledSocialLinks = styled(SocialLinks)`
  ${PAtom} {
    ${vars.fontSize2}
    font-weight: ${vars.fontWeightRegular};
    padding-bottom: ${vars.spacingM};
    &::first-letter {
      text-transform: uppercase;
    }
  }
  ul {
    display: flex;
    align-items: center;
    list-style-type: none;
    ${SocialLink} {
      &:not(:last-of-type) {
        margin-right: ${vars.spacingM};
      }
    }
  }
`;

export const StyledMobileSocialLinks = styled(SocialLinks)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${vars.mobileNavBarHeight}; /* Make dynamic */
  width: 100%;
  z-index: ${vars.mobileNavBarZindex};
  background: ${vars.coreDarkGrey};
  animation: ${vars.defaultTransitionDuration} ${keyframes`${fadeIn}`} 1;
  ${PAtom} {
    display: none;
  }
  ul {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    list-style-type: none;
    li {
      margin: 0 auto;
      svg {
        transform: scale(0.7);
      }
    }
  }
`;
